import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { AlertifyService } from './alertify.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  private isHandling401 = false;
  
  constructor(
    private dialog: MatDialog,
    private alertify: AlertifyService)
    {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {    
    const token = localStorage.getItem('token');
    const isWindowsAuthRequest = req.url.includes(environment.apiWindowsAuthUrl);

    if (isWindowsAuthRequest) {
      req = req.clone({
        withCredentials: true
      });
    } else if (token) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
        .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
        .set('If-Modified-Since', '0')
        });
    }
    return next.handle(req).pipe(
      tap(
        () => {},
        error => {
          if (error.status === 401) {
            if (this.isHandling401) {
              return;
            }
            
            this.isHandling401 = true;
            
            const tokenBindingFailed = error.headers && error.headers.get('X-Token-Binding-Failed');
            const tokenExpired = error.headers && error.headers.get('X-Token-Expired');
                        
            localStorage.removeItem('token');
            
            let message: string;
            if (tokenBindingFailed === 'true') {
              message = 'Your network connection changed. Please log in again.';
            } else if (tokenExpired === 'true') {
              message = 'Your session has expired. Please log in again.';
            } else {
              message = 'Authentication failed. Please log in again.';
            }
            
            sessionStorage.setItem('auth_message', message);
            
            this.dialog.closeAll();
            
            window.location.href = '/search';

            this.isHandling401 = false;
            
          } else if (error.status === 403) {
            this.alertify.message('You do not have permission to perform that function');
          }
        }
      )
    );
  }
}